import { getQuestion } from "@/src/models/getQuestions";
import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { IGetQuestionsStateAndAction, initialState } from "./initialState";

export const useGetQuestionsStore = create<IGetQuestionsStateAndAction>()(
  devtools(
    persist(
      (set, get) => ({
        ...initialState,
        getReviewQuestion: async () => {
          const questions = await getQuestion();
          set({ questions });
        },
      }),
      {
        name: "get-questions-storage",
        storage: createJSONStorage(() => sessionStorage),
      },
    ),
    {
      name: "get-questions-store",
    },
  ),
);
